var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refresh-page"},[_vm._v("页面刷新中...")])
}
var staticRenderFns = []

export { render, staticRenderFns }